import { jsx as _jsx } from "react/jsx-runtime";
import Chip from '@mui/material/Chip';
import { orange, teal } from '@mui/material/colors';
import { FormattedMessage } from 'react-intl';
import { defineStyles, theme } from '../theme';
const styles = defineStyles({
    logicChip: {
        borderRadius: 1,
        px: 0,
        fontWeight: 500,
    },
    andChip: {
        backgroundColor: teal[50],
        color: theme.vars.palette.primary.main,
    },
    orChip: {
        backgroundColor: orange[50],
        color: orange[700],
    },
});
export function AndChip() {
    return (_jsx(Chip, { label: _jsx(FormattedMessage, { id: "filter.operator.and", defaultMessage: "and" }), size: "small", sx: [styles.logicChip, styles.andChip] }));
}
export function OrChip() {
    return (_jsx(Chip, { label: _jsx(FormattedMessage, { id: "filter.operator.or", defaultMessage: "or" }), size: "small", sx: [styles.logicChip, styles.orChip] }));
}
//# sourceMappingURL=FilterLogicChips.js.map